// extracted by mini-css-extract-plugin
export default {"contactButton":"contactButton_contactButton__dBCVQ","Shimiring":"contactButton_Shimiring__S4GmQ"};